<script>
 import wx from "weixin-js-sdk";
export default {
  name: 'RedirectPlatform',
  data() {
    return {
      redirectUrl: 'http://zxyy.jsltpct.cn/login'
    }
  },
  created() {
    // 获取当前URL中的code参数
    const code = this.getUrlParam('code')
    const state = this.getUrlParam('state')
    const weChat = this.getUrlParam('weChat')
    console.log('重定向过来',code,state,weChat)
    if(weChat && code) {
        wx.miniProgram.navigateTo({
          url: `/pages/index/index?code=${code}`,
          success: () => {
            console.log('跳回小程序成功');
            this.loading = false;
          },
          fail: (err) => {
            console.error('跳回小程序失败：', err);
            this.loading = false;
            this.errorMsg = '跳回小程序失败，请手动返回';
          }
        })
    } else if (code) {
      // 如果有code，说明是从微信授权回调回来的，需要将code传给目标页面
      const targetUrl = `${this.redirectUrl}?code=${code}`
      window.location.href = targetUrl
    } else {
      // 如果没有code，需要发起微信授权
      this.redirectToWechatAuth()
    }
  },
  methods: {
    // 获取URL参数
    getUrlParam(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURIComponent(r[2])
      return null
    },
    // 重定向到微信授权页面
    redirectToWechatAuth() {
      // 注意：这里的APPID需要替换为实际的公众号APPID
      const appId = process.env.VUE_APP_WECHAT_APPID || 'YOUR_APPID'
      
      // 当前页面的URL，作为授权后的回调地址
      const redirectUri = encodeURIComponent(window.location.href)
      
      // 构建微信授权URL，使用snsapi_userinfo获取用户信息
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      
      // 重定向到微信授权页面
      window.location.href = authUrl
    }
  }
}
</script>

<template>
  <div class="redirect-container">
    <div class="loading">
      <p>授权中，请稍候...</p>
    </div>
  </div>
</template>

<style>
.redirect-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}
.loading {
  font-size: 16px;
  color: #666;
}
</style>